import React, { useState } from 'react';
import './TestimonialCard.css';

function TestimonialCard({ name, feedback, rating }) {
    const [expanded, setExpanded] = useState(false);

    const getInitials = (fullName) => {
        const parts = fullName.trim().split(' ');
        const first = parts[0]?.[0] || '';
        const last = parts[1]?.[0] || '';
        return (first + last).toUpperCase();
    };

    const getColorFromName = (name) => {
        let hash = 0;
        for (let i = 0; i < name.length; i++) {
            hash = name.charCodeAt(i) + ((hash << 5) - hash);
        }
        const hue = hash % 360;
        return `hsl(${hue}, 60%, 60%)`;
    };

    return (
        <div className="testimonial-card">
            <div
                className="avatar"
                style={{ backgroundColor: getColorFromName(name) }}
            >
                {getInitials(name)}
            </div>
            <h4 className="testimonial-name">{name}</h4>
            <p className={`testimonial-feedback ${expanded ? 'expanded' : 'collapsed'}`}>
                “{feedback}”
            </p>
            {feedback.length > 150 && (
                <span className="read-more" onClick={() => setExpanded(!expanded)}>
                    {expanded ? 'Show less' : 'Read more'}
                </span>
            )}
            {rating && <div className="rating-display">{'⭐'.repeat(rating)}</div>}
        </div>
    );
}

export default TestimonialCard;
